export const AnalyticsEvent = {
  Register: 'register',
  SignIn: 'sign_in',
  SignOut: 'sign_out',
  EmailVerified: 'email_verified',
  EmailSent: 'email_sent',
  EmailFailed: 'email_failed',
  EmailBounced: 'email_bounced',
  EmailComplained: 'email_complained',
  PasswordResetRequested: 'password_reset_requested',
  PasswordRejectedWeak: 'password_rejected_weak',
  PasswordRejectedBreached: 'password_rejected_breached',
  ProfileCreated: 'profile_created',
  GearItemCreated: 'gear_item_created',
  GearItemUpdated: 'gear_item_updated',
  GearItemDeleted: 'gear_item_deleted',
  GearItemMoved: 'gear_item_moved',
  GearRenamed: 'gear_renamed',
  GearCategoryCreated: 'gear_category_created',
  GearCategoryRenamed: 'gear_category_renamed',
  GearCategoryDeleted: 'gear_category_deleted',
  GearImportStarted: 'gear_import_started',
  GearImportCompleted: 'gear_import_completed',
  PlanLimitBlocked: 'plan_limit_blocked',
} as const;

export type PasswordRejectionSurface = 'register' | 'reset-password';

export type BreachCountBucket = '1-10' | '11-100' | '101-1000' | '1000+';

/**
 * Buckets a HIBP breach count to avoid uniquely identifying which leak the
 * password came from. Always send the bucket, never the raw count.
 */
export function bucketBreachCount(count: number): BreachCountBucket {
  if (count <= 10) return '1-10';
  if (count <= 100) return '11-100';
  if (count <= 1000) return '101-1000';
  return '1000+';
}
